import { parseCatalogSearch } from "./components/CatalogTools";
import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const productsIndex = lazyWithRetry(() => import("./routes/products"));
const productNew = lazyWithRetry(() => import("./routes/products/new"));
const productEdit = lazyWithRetry(() => import("./routes/products/[id]/edit"));
const productsImportExport = lazyWithRetry(
  () => import("./routes/products/import-export"),
);
const productTranslations = lazyWithRetry(
  () => import("./routes/products/translations"),
);
const barcodesIndex = lazyWithRetry(() => import("./routes/barcodes"));
const productReviewsIndex = lazyWithRetry(() => import("./routes/reviews"));
const productQuestionsIndex = lazyWithRetry(() => import("./routes/questions"));
const categoriesIndex = lazyWithRetry(() => import("./routes/categories"));
const brandsIndex = lazyWithRetry(() => import("./routes/brands"));
const labelsIndex = lazyWithRetry(() => import("./routes/labels"));
const attributesIndex = lazyWithRetry(() => import("./routes/attributes"));

const productsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/products",
  beforeLoad: () => ({
    breadcrumbs: [
      { label: "Dashboard", to: "/" },
      { label: "Catalog", to: "/catalog" },
      { label: "Products" },
    ],
  }),
  component: () =>
    renderProtectedRoute(productsIndex, { requirePerms: ["catalog:read"] }),
});

const productNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/products/new",
  beforeLoad: () => ({
    breadcrumbs: [
      { label: "Dashboard", to: "/" },
      { label: "Catalog", to: "/catalog" },
      { label: "Products", to: "/catalog/products" },
      { label: "New Product" },
    ],
  }),
  component: () =>
    renderProtectedRoute(productNew, { requirePerms: ["catalog:read"] }),
});

const productEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/products/$id/edit",
  beforeLoad: ({ params: _params }) => ({
    breadcrumbs: [
      { label: "Dashboard", to: "/" },
      { label: "Catalog", to: "/catalog" },
      { label: "Products", to: "/catalog/products" },
      { label: "Edit Product" },
    ],
  }),
  component: () =>
    renderProtectedRoute(productEdit, { requirePerms: ["catalog:read"] }),
});

const productsImportExportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/products/import-export",
  component: () =>
    renderProtectedRoute(productsImportExport, {
      requirePerms: ["catalog:read"],
    }),
});
const productTranslationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/products/translations",
  beforeLoad: () => ({
    breadcrumbs: [
      { label: "Dashboard", to: "/" },
      { label: "Catalog", to: "/catalog" },
      { label: "Products", to: "/catalog/products" },
      { label: "Translations" },
    ],
  }),
  component: () =>
    renderProtectedRoute(productTranslations, {
      requirePerms: ["catalog:write"],
    }),
});
const barcodesIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/barcodes",
  validateSearch: parseCatalogSearch,
  component: () =>
    renderProtectedRoute(barcodesIndex, { requirePerms: ["catalog:read"] }),
});
const productReviewsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/reviews",
  validateSearch: parseCatalogSearch,
  component: () =>
    renderProtectedRoute(productReviewsIndex, {
      requirePerms: ["catalog:read"],
    }),
});
const productQuestionsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/questions",
  validateSearch: parseCatalogSearch,
  component: () =>
    renderProtectedRoute(productQuestionsIndex, {
      requirePerms: ["catalog:read"],
    }),
});

const categoriesIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/categories",
  beforeLoad: () => ({
    breadcrumbs: [
      { label: "Dashboard", to: "/" },
      { label: "Catalog", to: "/catalog" },
      { label: "Categories" },
    ],
  }),
  component: () =>
    renderProtectedRoute(categoriesIndex, { requirePerms: ["catalog:read"] }),
});

const brandsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/brands",
  beforeLoad: () => ({
    breadcrumbs: [
      { label: "Dashboard", to: "/" },
      { label: "Catalog", to: "/catalog" },
      { label: "Brands" },
    ],
  }),
  component: () =>
    renderProtectedRoute(brandsIndex, { requirePerms: ["catalog:read"] }),
});

const labelsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/labels",
  validateSearch: parseCatalogSearch,
  beforeLoad: () => ({
    breadcrumbs: [
      { label: "Dashboard", to: "/" },
      { label: "Catalog", to: "/catalog" },
      { label: "Labels" },
    ],
  }),
  component: () =>
    renderProtectedRoute(labelsIndex, { requirePerms: ["catalog:read"] }),
});

const attributesIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/catalog/attributes",
  component: () =>
    renderProtectedRoute(attributesIndex, { requirePerms: ["catalog:read"] }),
});

export const catalogRouteTree = [
  productNewRoute,
  productEditRoute,
  productsImportExportRoute,
  productTranslationsRoute,
  productsIndexRoute,
  barcodesIndexRoute,
  productReviewsIndexRoute,
  productQuestionsIndexRoute,
  categoriesIndexRoute,
  brandsIndexRoute,
  labelsIndexRoute,
  attributesIndexRoute,
];
